import { useEffect } from 'react'

import { trackEvent } from '~/shared/lib/analytics'

import { DOCUMENT_STEP_VIEW } from '../config'
import { setStepStartTime } from '../lib/storage'

import { useStepSession } from './step-session-context'

export function useStepView() {
  const { step, documentKey } = useStepSession()

  useEffect(() => {
    if (!documentKey) return
    trackEvent(DOCUMENT_STEP_VIEW, { step, document_key: documentKey })
    setStepStartTime(documentKey, step)
  }, [step, documentKey])
}
